/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-23 10:02:54
 * @LastEditTime: 2020-12-09 13:47:16
 * @FilePath: \ensurance-front\src\store\modules\router.js
 */
import store from 'store'
const state = {
  // eslint-disable-next-line no-undef
  routerPath: store.get('routerPath') || []
}

const mutations = {
  // 设置路由数据
  setRouter(state, paylod) {
    state.routerPath = paylod
    store.set('routerPath', paylod)
  }
}
const actions = {
  getRouterPath({ commit }) {
    commit('routerPath')
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/router.js